import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../material.module';
import { UserSearchDialogComponent, UserSearchDialogResult } from '../user-search-dialog/user-search-dialog.component';

export interface AlternateCustomersDialogData {
    customers: string[];
}

@Component({
    selector: 'app-alternate-customers-dialog',
    standalone: true,
    imports: [CommonModule, FormsModule, MaterialModule],
    templateUrl: './alternate-customers-dialog.component.html',
    styleUrls: ['./alternate-customers-dialog.component.css'],
})
export class AlternateCustomersDialogComponent {
    customers: string[] = [];

    constructor(
        private readonly dialogRef: MatDialogRef<AlternateCustomersDialogComponent, string[]>,
        @Inject(MAT_DIALOG_DATA) public data: AlternateCustomersDialogData,
        private readonly dialog: MatDialog,
    ) {
        this.customers = (data?.customers ?? []).map((email) => email?.trim()).filter((email) => !!email);
    }

    private readonly emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    isInvalidEmail(email: string): boolean {
        const v = (email ?? '').trim();
        return !!v && !this.emailRegex.test(v);
    }

    get hasEmptyField(): boolean {
        return this.customers.some((email) => !email?.trim());
    }

    get hasInvalidEmail(): boolean {
        return this.customers.some((email) => this.isInvalidEmail(email));
    }

    get hasFormError(): boolean {
        return this.hasEmptyField || this.hasInvalidEmail;
    }

    openSearch(index: number): void {
        const ref = this.dialog.open(UserSearchDialogComponent, {
            data: { fieldLabel: 'Alternate Customer' },
            width: '1400px',
            maxWidth: '95vw',
        });
        ref.afterClosed().subscribe((result: UserSearchDialogResult | undefined) => {
            if (result?.email) {
                this.customers[index] = result.email;
            }
        });
    }

    addRow(): void {
        this.customers.push('');
    }

    removeRow(index: number): void {
        if (index < 0 || index >= this.customers.length) {
            return;
        }
        this.customers.splice(index, 1);
    }

    close(): void {
        this.dialogRef.close();
    }

    save(): void {
        const deduped = Array.from(new Set(
            this.customers
                .map((email) => (email ?? '').trim())
                .filter((email) => !!email)
        ));

        this.dialogRef.close(deduped);
    }
}
